import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { URL_FILES } from "../../../constans/apis";
import { getFileDataUrlFetch } from "../../../lib/files/api/fetchFile";
import withPrefix from "../../../helpers/useQueryPrefix";

/**
 * Descarga el logotipo de la empresa desde el servicio de archivos y lo entrega
 * como data URI, listo para `<img src>` y para `<Image>` de @react-pdf/renderer.
 *
 * Se cachea de forma agresiva: el UUID cambia cada vez que se sustituye el logo,
 * así que el contenido de un UUID dado es inmutable.
 */
export const useCompanyLogoImage = (uuidLogo?: string): UseQueryResult<string> => {
  const uuid = uuidLogo?.trim() ?? "";

  return useQuery<string>({
    queryKey: withPrefix(["company", "logo", "image", uuid]),
    enabled: uuid.length > 0,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
    queryFn: () => getFileDataUrlFetch(`${URL_FILES}/${uuid}`, TOKEN_FILES),
  });
};
